module.exports = __webpack_public_path__ + "static/media/Arrow up.dc18bfd0.svg";